import React from "react";
import { Calculation } from "../../../../../../src/application/Contracts";
import BaseTechTable from "./BaseTechTable";

export default class AlfaPilotTable extends BaseTechTable<Calculation.AquaPilotTechnicalData[]> {
    enabledIndirectDirectButton = false;
    getItems = () => {
        return Object.values(this.props.items.filter(i => i.temperatureProgram == this.getFilterTemperatureProgram())).sort(
            (a, b) => {
                if (a.dimensions > b.dimensions) {
                    return 1;
                } else if (a.dimensions < b.dimensions) {
                    return -1;
                } else {
                    return 0;
                }
            }
        );
    }
    getCurrency = (): string => {
        return this.getItems()[0]?.currency || "";
    }

    getTable() {
        return <table>
            <thead>
                <tr>
                    <th rowSpan={2}>{__("Model")}</th>
                    <th colSpan={2}>{__("Control valve")}</th>
                    <th rowSpan={2} colSpan={3}>{__("Primary flow rate (m3/h)")}</th>
                    <th rowSpan={2} colSpan={3}>{__("Primary pressure loss (kPa)")}</th>
                    <th rowSpan={2}>{__("Dimensions")}</th>
                    <th rowSpan={2}>{__("Weight (kg)")}</th>
                    <th rowSpan={2}>{__("Article no.")}</th>
                    <th rowSpan={2}>{__("Public price" + " " + this.getCurrency())}</th>
                </tr>
                <tr>
                    <th>{__("diameter")}</th>
                    <th>{__("KvS")}</th>
                </tr>
            </thead>
            <tbody>
                {this.getItems().map(item => {
                    return <tr key={item.partnumber}>
                        <td>{item.model}</td>
                        <td>{item.controlValveDiameter}</td>
                        <td>{item.controlValveKvs}</td>
                        {item.primaryFlowRates?.map(i => {
                            return <React.Fragment key={i}>
                                <td>{i}</td>
                            </React.Fragment>
                        })}
                        {item.primaryPressureLosses?.map(i => {
                            return <React.Fragment key={i}>
                                <td>{i}</td>
                            </React.Fragment>
                        })}
                        <td>{item.dimensions}</td>
                        <td>{item.weight}</td>
                        <td>{item.partnumber}</td>
                        <td>{item.price}</td>
                    </tr>
                })}
            </tbody>
        </table>
    }
}